angular.module('bmsApp.dashboard')
	.controller('DashboardTicketIndexCtrl', function ($scope,
													  $rootScope,
													  $state,
													  $q,
													  $timeout,
													  ngTableParams,
													  FranchiseSvc,
													  SMScheduleSvc,
													  SMJobSvc,
													  ActivitySvc,
													  TGProductSvc,
													  CustomerSvc,
													  TicketSvc) {

		var self = this;

		self.methods = {
			init: init,
			onRowClicked: onRowClicked
		};

		$rootScope.$on('onTickedAdded', function() {
			self.tableParamsTickets.reload();
		});

		function init() {
			self.tableParamsTickets = new ngTableParams(angular.extend({
				page: 0,
				sorting: {created_at: 'desc'}
			}), {
				total: 0, // length of data
				counts: null,
				getData: function ($defer, params) {
					TicketSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.tickets_count);
							$defer.resolve(response.data.tickets);
						});

				}
			});
		}

		function onRowClicked(item) {
			$state.go('main.dashboard.tickets.save', {ticketId: item.id});
		}

	});